import SC from 'styled-components'

export const RiskLevelSpan = SC.span`
  font-weight: bold;
`
